/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DHSurveyJobDefinition } from '../models/DHSurveyJobDefinition';
import type { ListFamiliesResponse } from '../models/ListFamiliesResponse';
import type { ListMappedDataCutsResponseItem } from '../models/ListMappedDataCutsResponseItem';
import type { Survey } from '../models/Survey';
import type { SurveyDataCut } from '../models/SurveyDataCut';
import type { SurveyDataCutSort } from '../models/SurveyDataCutSort';
import type { SurveyGeoFilterOption } from '../models/SurveyGeoFilterOption';
import type { SurveyIndustryFilterOption } from '../models/SurveyIndustryFilterOption';
import type { SurveyJobFamily } from '../models/SurveyJobFamily';
import type { SurveyJobLevel } from '../models/SurveyJobLevel';
import type { SurveyJobSearchField } from '../models/SurveyJobSearchField';
import type { SurveyJobSort } from '../models/SurveyJobSort';
import type { SurveyModule } from '../models/SurveyModule';
import type { SurveyVendor } from '../models/SurveyVendor';
import type { VendorLevelProfileType } from '../models/VendorLevelProfileType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyService {

    /**
     * Get list of surveys
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyList({
        requestBody,
    }: {
        requestBody?: {
            /**
             * Survey Vendor Id
             */
            surveyVendor?: Array<string>;
            /**
             * Survey Module Id
             */
            surveyModuleId?: Array<string>;
            /**
             * Filter surveys by mapping type
             */
            mapping?: 'STANDARD' | 'CUSTOM';
            /**
             * When true, return only surveys reconstructable from raw source (cloneable / reprocessable)
             */
            reprocessable?: boolean;
            /**
             * Survey Job Profile id
             */
            surveyJobProfileId?: string;
            /**
             * Page number
             */
            offset?: number;
            /**
             * Max items per page
             */
            limit?: number;
            ignorePagination?: boolean;
            planId?: Array<number>;
            paymarket?: Array<string>;
            search?: string;
            status?: string;
            /**
             * When provided alone, returns only unassigned surveys. When provided with planId, returns surveys in specified plans OR unassigned (OR logic)
             */
            unassigned?: boolean;
            currencyId?: string;
            idNotIn?: Array<string>;
            idIn?: Array<string>;
            sort?: {
                surveyName?: string;
                surveyVendorName?: string;
                vendorFieldMappingProfileName?: string;
                effectiveDate?: string;
                createdAt?: string;
                updatedAt?: string;
            };
            includeSurveyJobsDataCutsStatistics?: boolean;
        },
    }): CancelablePromise<{
        rows: Array<Survey>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/survey',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of survey vendors
     * @returns any Success
     * @throws ApiError
     */
    public static listVendors({
        withParticipationOnly,
        withVisible,
        withSurveyCounts,
    }: {
        withParticipationOnly?: boolean,
        withVisible?: boolean,
        /**
         * Include surveysCount on each vendor - how many surveys the caller's tenant already has for it. Off by default: it costs an extra aggregate in DataHub, so only callers that render the count should ask for it.
         */
        withSurveyCounts?: boolean,
    }): CancelablePromise<{
        rows?: Array<SurveyVendor>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/vendor',
            query: {
                'withParticipationOnly': withParticipationOnly,
                'withVisible': withVisible,
                'withSurveyCounts': withSurveyCounts,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Filters
     * @returns any Success
     * @throws ApiError
     */
    public static filters({
        survey,
        vendor,
        plan,
        companyJobLevel,
        companyJobGlobalGrade,
        currencyId,
    }: {
        survey?: Array<string>,
        vendor?: Array<string>,
        plan?: Array<number>,
        companyJobLevel?: Array<number>,
        companyJobGlobalGrade?: Array<number>,
        currencyId?: number,
    }): CancelablePromise<{
        effectiveDates?: Array<string>;
        jobFamilies?: Array<SurveyJobFamily>;
        careerLevels?: Array<SurveyJobLevel>;
        globalLevels?: Array<SurveyJobLevel>;
        mappedJobLevels?: Array<SurveyJobLevel>;
        mappedJobGlobalLevels?: Array<SurveyJobLevel>;
        surveys?: Array<{
            id?: string;
            name?: string;
        }>;
        vendors?: Array<SurveyVendor>;
        industries?: Array<SurveyIndustryFilterOption>;
        locations?: Array<SurveyGeoFilterOption>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/filters',
            query: {
                'survey': survey,
                'vendor': vendor,
                'plan': plan,
                'companyJobLevel': companyJobLevel,
                'companyJobGlobalGrade': companyJobGlobalGrade,
                'currencyId': currencyId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export surveys
     * @returns string Success
     * @throws ApiError
     */
    public static exportSurveys(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/survey/export',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of jobs for Survey Job Profile
     * @returns any Success
     * @throws ApiError
     */
    public static listJobs({
        requestBody,
    }: {
        requestBody: {
            /**
             * Survey Job Profile ids
             */
            surveyJobProfileIds?: Array<string>;
            /**
             * Page number
             */
            offset?: number;
            /**
             * Max items per page
             */
            limit?: number;
            sort?: SurveyJobSort;
            search?: Array<string>;
            careerLevel?: Array<string>;
            globalLevel?: Array<string> | null;
            jobSubFamily?: Array<string>;
            jobFamily?: Array<string>;
            jobFocus?: Array<string>;
            jobType?: string | null;
            companyJobId?: number;
            plan?: Array<number>;
            paymarketId?: number | null;
            module?: Array<string>;
            purchasedOnly?: boolean;
            recommendationMode?: 'semantic_ordering' | 'similarity_scores';
            searchFields?: Array<SurveyJobSearchField>;
        },
    }): CancelablePromise<{
        count?: number;
        rows?: Array<DHSurveyJobDefinition>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/survey/jobprofile/job',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of levels for Survey Job Profile
     * @returns any Success
     * @throws ApiError
     */
    public static listSurveyLevels({
        vendorLevelProfileIds,
        plan,
        surveyJobProfiles,
        survey,
        vendor,
        sort,
        search,
        type,
    }: {
        /**
         * Vendor Level Profile IDs
         */
        vendorLevelProfileIds?: Array<string>,
        plan?: Array<number>,
        surveyJobProfiles?: Array<string>,
        survey?: Array<string>,
        vendor?: Array<string>,
        sort?: string,
        search?: string,
        type?: VendorLevelProfileType,
    }): CancelablePromise<{
        count?: number;
        rows: Array<SurveyJobLevel>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/jobprofile/level',
            query: {
                'vendorLevelProfileIds': vendorLevelProfileIds,
                'plan': plan,
                'surveyJobProfiles': surveyJobProfiles,
                'survey': survey,
                'vendor': vendor,
                'sort': sort,
                'search': search,
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of families for Survey Job Profile
     * @returns any Success
     * @throws ApiError
     */
    public static listFamilies({
        surveyJobProfileIds,
        sort,
    }: {
        /**
         * Survey Job Profile id
         */
        surveyJobProfileIds: Array<string>,
        sort?: string,
    }): CancelablePromise<{
        count?: number;
        rows: Array<ListFamiliesResponse>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/jobprofile/family',
            query: {
                'surveyJobProfileIds': surveyJobProfileIds,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of modules for Survey Job Profile
     * @returns any Success
     * @throws ApiError
     */
    public static listSurveyModules({
        surveyJobProfileIds,
        participationId,
    }: {
        /**
         * Survey Job Profile id
         */
        surveyJobProfileIds: Array<string>,
        /**
         * Participation Id
         */
        participationId?: string,
    }): CancelablePromise<{
        rows?: Array<SurveyModule>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/jobprofile/module',
            query: {
                'surveyJobProfileIds': surveyJobProfileIds,
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Apply Default Survey Mappings
     * @returns any Success
     * @throws ApiError
     */
    public static applyDefaultMappings({
        surveyJobProfileId,
        requestBody,
    }: {
        /**
         * Target Survey Job Profile id
         */
        surveyJobProfileId: string,
        requestBody: {
            plan: number;
            sourceSurveyJobProfileId: string;
            companyJobIds: (string | Array<number>);
        },
    }): CancelablePromise<{
        rows?: {
            success?: boolean;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/survey/jobprofile/{surveyJobProfileId}/applyDefaultMappings',
            path: {
                'surveyJobProfileId': surveyJobProfileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Data Cuts
     * @returns any Success
     * @throws ApiError
     */
    public static listMappedDataCuts({
        surveyId,
        paymarketId,
        offset,
        limit,
        sort,
        organizations,
        incumbents,
        prevalence,
        jobsCount,
        search,
    }: {
        surveyId: string,
        paymarketId: number,
        /**
         * Page number
         */
        offset?: number,
        /**
         * Max items per page
         */
        limit?: number,
        sort?: SurveyDataCutSort,
        organizations?: number,
        incumbents?: number,
        prevalence?: number,
        jobsCount?: number,
        search?: string,
    }): CancelablePromise<{
        rows: Array<ListMappedDataCutsResponseItem>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/{surveyId}/mappedDataCut',
            path: {
                'surveyId': surveyId,
            },
            query: {
                'paymarketId': paymarketId,
                'offset': offset,
                'limit': limit,
                'sort': sort,
                'organizations': organizations,
                'incumbents': incumbents,
                'prevalence': prevalence,
                'jobsCount': jobsCount,
                'search': search,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Data Cuts
     * @returns SurveyDataCut Success
     * @throws ApiError
     */
    public static listDataCuts({
        surveyId,
        offset,
        limit,
        organizations,
        incumbents,
        prevalence,
        search,
        currencyId,
        recommendationMode,
        sort,
    }: {
        surveyId: string,
        /**
         * Page number
         */
        offset?: number,
        /**
         * Max items per page
         */
        limit?: number,
        organizations?: number,
        incumbents?: number,
        prevalence?: number,
        search?: string,
        currencyId?: number,
        recommendationMode?: 'semantic_ordering' | 'similarity_scores',
        sort?: SurveyDataCutSort,
    }): CancelablePromise<Array<SurveyDataCut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/{surveyId}/dataCut',
            path: {
                'surveyId': surveyId,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'organizations': organizations,
                'incumbents': incumbents,
                'prevalence': prevalence,
                'search': search,
                'currencyId': currencyId,
                'recommendationMode': recommendationMode,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get survey
     * @returns Survey Success
     * @throws ApiError
     */
    public static getSurvey({
        surveyId,
    }: {
        surveyId: string,
    }): CancelablePromise<Survey> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/{surveyId}',
            path: {
                'surveyId': surveyId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Survey
     * @returns any Success
     * @throws ApiError
     */
    public static updateSurvey({
        surveyId,
        requestBody,
    }: {
        /**
         * Survey ID
         */
        surveyId: string,
        requestBody: {
            name: string;
            plans?: Array<number>;
            paymarkets?: Array<number>;
        },
    }): CancelablePromise<{
        survey: Survey;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/survey/{surveyId}',
            path: {
                'surveyId': surveyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
